// extracted by mini-css-extract-plugin
export default {"arrowHeadAlt":"TableToggle_arrowHeadAlt__QblUA","arrowAlt":"TableToggle_arrowAlt__supmz"};